import { Output_Inst } from './output_Inst';
import { Attribute } from './attribute';
import { CommonEnums } from 'src/app/shared/common.enums';
import { AttributesUtil } from 'src/app/shared/grids/attributes/attributes.util';

export class Output {
    output_Inst: Output_Inst;
    attributes: Array<Attribute>;

    nativeDbTyp_Id: number;
    ref_Id: number;
    ref_Cd: string;
    fldr_Id: number;

    change_Ind: string;
    gen_Tab_Change_Ind: string;
    attr_Tab_Change_Ind: string;
    outmapr_Tab_Change_Ind: string;

    error_Cd: string;
    error_Msg: string;

    constructor() {
        this.setDefaults()
    }

    setDefaults(): void {
        this.output_Inst = new Output_Inst();
        this.attributes = new Array<Attribute>();

        this.nativeDbTyp_Id = CommonEnums.defaults.DEFAULT_INT_VAL;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;

        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.gen_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.attr_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.outmapr_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;

        this.error_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
    }

    static parse(outputTmp: Output): Output {
        let output: Output = new Output();
        output.copyFrom(outputTmp);
        return output;
    }

    copy(): Output {
        let outputTmp: Output = new Output();

        outputTmp.output_Inst = this.output_Inst.copy();
        AttributesUtil.getInstance().copy(this.attributes);

        outputTmp.nativeDbTyp_Id = this.nativeDbTyp_Id;
        outputTmp.ref_Id = this.ref_Id;
        outputTmp.ref_Cd = this.ref_Cd;
        outputTmp.fldr_Id = this.fldr_Id;

        outputTmp.change_Ind = this.change_Ind;
        outputTmp.gen_Tab_Change_Ind = this.gen_Tab_Change_Ind;
        outputTmp.attr_Tab_Change_Ind = this.attr_Tab_Change_Ind;
        outputTmp.outmapr_Tab_Change_Ind = this.outmapr_Tab_Change_Ind;

        outputTmp.error_Cd = this.error_Cd;
        outputTmp.error_Msg = this.error_Msg;

        return outputTmp;
    }

    copyFrom(outputTmp: Output): void {
        this.output_Inst.copyFrom(outputTmp.output_Inst);
        AttributesUtil.getInstance().copyFrom(this.attributes, outputTmp.attributes);

        this.nativeDbTyp_Id = outputTmp.nativeDbTyp_Id;
        this.ref_Id = outputTmp.ref_Id;
        this.ref_Cd = outputTmp.ref_Cd;
        this.fldr_Id = outputTmp.fldr_Id;

        this.change_Ind = outputTmp.change_Ind;
        this.gen_Tab_Change_Ind = outputTmp.gen_Tab_Change_Ind;
        this.attr_Tab_Change_Ind = outputTmp.attr_Tab_Change_Ind;
        this.outmapr_Tab_Change_Ind = outputTmp.outmapr_Tab_Change_Ind;

        this.error_Cd = outputTmp.error_Cd;
        this.error_Msg = outputTmp.error_Msg;
    }

    compare(outputTmp: Output): string {
        let outputString: string = toString();
        let outputTmpString: string = outputTmp.toString();

        if (outputString != outputTmpString) {
            return outputString + ', ' + outputTmpString
        }
        return '';
    }

    toString(): string {
        return "Output[output_Inst=" + this.output_Inst.toString() +
            ", attributes=" + AttributesUtil.getInstance().toString(this.attributes) +
            ", change_Ind=" + this.change_Ind +
            ", error_Cd =" + this.error_Cd +
            ", error_Msg=" + this.error_Msg +
            ", nativeDbTyp_Id=" + this.nativeDbTyp_Id +
            ", ref_Id=" + this.ref_Id +
            ", ref_Cd=" + this.ref_Cd +
            ", fldr_Id=" + this.fldr_Id +
            ", gen_Tab_Change_Ind=" + this.gen_Tab_Change_Ind +
            ", attr_Tab_Change_Ind=" + this.attr_Tab_Change_Ind +
            ", outmapr_Tab_Change_Ind=" + this.outmapr_Tab_Change_Ind + "]";
    }
}